// ------------------------------------------------------
export function getBool(val: any): boolean {
    if (val != null) {
        if (isString(val))
            val = val.toLowerCase();
        switch (val) {
            case true:
            case "true":
            case 1:
            case "1":
            case "on":
            case "yes":
                return true;
        }
    }
    return false;
}
// ------------------------------------------------------
export function isDefined(obj: any): boolean {
    return !(obj == null);
}
// ------------------------------------------------------
export function isString(obj: any): obj is string {
    return (typeof obj === 'string' || obj instanceof String)
}
// ------------------------------------------------------
export function isStringEmpty(str: any): boolean {
    return (!str || 0 === str.length);
}
// ------------------------------------------------------
// todo: rename, lowercase I, use old name as alias for backwards compatibility issues, this function is used in Gems now
export function IsNullOrEmpty(obj: string) {
    return !isDefined(obj) || obj.length == 0;
}
// ------------------------------------------------------
// todo: rename, lowercase I, use old name as alias for backwards compatibility issues, this function is used in Gems now
export function IsNullOrWhiteSpace(obj: string) {
    return !isString(obj) || obj.trim().length == 0;
}
// ------------------------------------------------------
export function isFunction(obj: any): boolean {
    return (typeof obj === 'function' || obj instanceof Function)
}
// ------------------------------------------------------
export function isObject(obj: any): boolean {
    return (obj === Object(obj))
}
// ------------------------------------------------------
export function isBool(obj: any): boolean {
    return isDefined(obj) && (typeof obj === 'boolean')
}
// ------------------------------------------------------
export function isNumeric(obj: any): boolean {
    return isDefined(obj) && (Number(parseFloat(obj)) == obj);
}
// ------------------------------------------------------
export function getRandomKey(): string {
    return Math.round(Math.random() * 0xFFFFFFFF).toString(16).toUpperCase();
}
// ------------------------------------------------------
export function getRandomSmallKey(): string {
    return Math.round(Math.random() * 0xFFFF).toString(16).toUpperCase();
}
// ------------------------------------------------------
export function getRandomColor(): string {
    return '#' + Math.random().toString(16).slice(-6);
}
// ------------------------------------------------------
export function RunSafe(func: any, ...args: any[]) {
    try {
        if (isFunction(func))
            (func as Function).apply(undefined, args);
    } catch (__) { }
}
// ------------------------------------------------------
export function getUrlParameters(): { [key: string]: string } {
    var sPageURL = window.location.search.substring(1);
    var sURLVariables = sPageURL.split('&');
    var res = {};
    for (var i = 0; i < sURLVariables.length; i++) {
        var sParameter = sURLVariables[i].split('=');
        res[sParameter[0]] = sParameter[1];
    }
    return res;
}
// ------------------------------------------------------
export function JSONSafeStringify(
    obj: Object,
    replacer?: (key, value) => string,
    spaces?: string | number,
    cycleReplacer?: (key, value) => string) {

    var stack = [], keys = [];
    if (cycleReplacer == null) cycleReplacer = (key, value) => {
        if (stack[0] === value) return "[Circular ~]"
        return "[Circular ~." + keys.slice(0, stack.indexOf(value)).join(".") + "]"
    }

    return JSON.stringify(obj,
        function (key, value) {
            if (isFunction(value))
                return undefined;

            if (stack.length > 0) {
                var thisPos = stack.indexOf(this)
                ~thisPos ? stack.splice(thisPos + 1) : stack.push(this)
                ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key)
                if (~stack.indexOf(value)) value = cycleReplacer.call(this, key, value)
            }
            else stack.push(value)

            return replacer == null ? value : replacer.call(this, key, value)
        },
        spaces);
}
// ------------------------------------------------------